'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const ACTIVITY_STATUS = [
    'draft',
    'inactive',
    'archived',
    'upcoming',
    'live',
    'celebration',
    'finished',
];
const isActivityCampaign = (activity) => typeof activity === 'object' && activity !== null && 'type' in activity && activity.type === 'campaign';
const isActivityBreakingNews = (activity) => activity.type === 'breaking-news';

exports.ACTIVITY_STATUS = ACTIVITY_STATUS;
exports.isActivityBreakingNews = isActivityBreakingNews;
exports.isActivityCampaign = isActivityCampaign;
//# sourceMappingURL=activity.js.map
